import { axios } from "../../config/axios";

export const memberOffersAPI = {

  /**
   * Create a new member offer
   * @param {object} params
   * @returns {object}
   */
  createMemberOffer(params) {
    return axios.post(`/api/v3/member_offers`, params)
                .then(resp => resp.data);
  },

}
